<template>
  <div>
    <!-- <div class="box">
      <h2>Introduction</h2>
      <span
        class="description"
      >Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs.</span>
    </div>
    -->
    <LecturePdf v-if="lowerDisplay && lecture.type === 'PDF' && !loadSkelton" :url="lowerDisplay.url" :fileID="lowerDisplay.idpdf" :isDownload="lowerDisplay.isDownload" />
    <LecturePdf v-if="lowerDisplay && lecture.type === 'BOOK' && !loadSkelton" :url="lowerDisplay.url" :isDownload="lowerDisplay.isDownload" />
    <LectureImage v-if="lowerDisplay && lecture.type === 'IMG' && !loadSkelton" :urls="lowerDisplay.urls" />
    <LectureUrl v-if="lowerDisplay && lecture.type === 'URL' && !loadSkelton" :urls="lowerDisplay.urls" />
    <LectureBlog v-if="lowerDisplay && lecture.type === 'BLOG' && !loadSkelton" :textBlog="lowerDisplay.textBlog" />
    <LectureExam v-if="lowerDisplay && lecture.type === 'EXAM' && !loadSkelton"/>
    <v-skeleton-loader
      class="mb-6"
      type="article"
      v-if="loadSkelton"
    ></v-skeleton-loader>
  </div>
</template>

<script>
import LecturePdf from "./DisplayLectureByType/Pdf.vue";
import LectureImage from "./DisplayLectureByType/Image.vue";
import LectureUrl from "./DisplayLectureByType/Url.vue";
import LectureBlog from "./DisplayLectureByType/Blog.vue";
import LectureExam from "./DisplayLectureByType/Exam.vue";

export default {
  components: {
    LecturePdf,
    LectureImage,
    LectureUrl,
    LectureBlog,
    LectureExam
  },
  computed: {
    lowerDisplay() {
      return this.$store.getters.lowerDisplay?.fetchData;
    },
    loadSkelton() {
      return this.$store.getters.loadSkelton;
    },
    lecture() {
      return this.$store.getters.lowerDisplay
        ? this.$store.getters.lowerDisplay.lecture
        : {};
    }
  },
};
</script>